module.exports = __webpack_public_path__ + "img/ad05.b8921812.png";